import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsParagraphModule } from '../forms-paragraph/forms-paragraph.module';
import { FormsFormComponent } from './forms-form.component';

import { FormsGlobals } from '../../../models/forms/forms.enum';
import { FormsService } from '../forms.service';

// material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsSummaryModule } from '../forms-summary/forms-summary.module';
import {MatIconModule} from '@angular/material/icon';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';

@NgModule({
    declarations: [
        FormsFormComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FormsSummaryModule,
        FormsParagraphModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatButtonModule,
        MatSnackBarModule,
        MatIconModule,
        TdoControlsModule,
    ],
    exports: [
        FormsFormComponent
    ],
    providers: [
        FormsService,
        FormsGlobals
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class FormsFormModule { }
